import { render, staticRenderFns } from "./MoaModal.vue?vue&type=template&id=aaf2dea2&scoped=true&"
import script from "./MoaModal.vue?vue&type=script&lang=js&"
export * from "./MoaModal.vue?vue&type=script&lang=js&"
import style0 from "./MoaModal.vue?vue&type=style&index=0&id=aaf2dea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf2dea2",
  null
  
)

export default component.exports